import { render, staticRenderFns } from "./user-setting.vue?vue&type=template&id=4a2877ff&scoped=true"
import script from "./user-setting.vue?vue&type=script&lang=ts"
export * from "./user-setting.vue?vue&type=script&lang=ts"
import style0 from "./user-setting.vue?vue&type=style&index=0&id=4a2877ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2877ff",
  null
  
)

export default component.exports